import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const features = [
  {
    icon: 'ri-book-open-line',
    title: '全集免费',
    desc: '2000+韩漫资源完全免费，无需付费订阅，随时随地畅享阅读乐趣。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '下拉阅读',
    desc: '专为移动端优化的下拉式阅读体验，流畅翻页，单手操作毫无压力。',
  },
  {
    icon: 'ri-image-line',
    title: '高清画质',
    desc: '所有漫画均为高清扫描版本，画面清晰细腻，完美呈现韩漫精美画风。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '每日更新',
    desc: '编辑团队每日精选更新，热门连载第一时间同步，追更永不错过。',
  },
  {
    icon: 'ri-stack-line',
    title: '丰富分类',
    desc: '恋爱、动作、奇幻、悬疑等八大分类，智能推荐帮你找到最爱。',
  },
];

const milestones = [
  { year: '2023', title: '韩漫网上线', desc: '正式面向中文读者提供韩国漫画在线阅读服务' },
  { year: '2024', title: '资源突破1000部', desc: '收录韩漫资源突破千部大关，覆盖主流类型' },
  { year: '2025', title: '日活突破30万', desc: '日活跃读者突破30万，成为中文韩漫阅读首选平台' },
  { year: '2026', title: '全新改版升级', desc: '界面全新升级，阅读体验全面优化，资源突破2000部' },
];

const platformStats = [
  { value: '2,000+', label: '漫画资源', icon: 'ri-book-2-line' },
  { value: '50万+', label: '日活跃读者', icon: 'ri-user-line' },
  { value: '8', label: '漫画分类', icon: 'ri-price-tag-3-line' },
  { value: '99.9%', label: '服务可用率', icon: 'ri-cloud-line' },
];

const mediaCoverage = [
  { outlet: '动漫之家', quote: '韩漫网是目前中文圈最全面的韩国漫画聚合平台之一', year: '2024' },
  { outlet: '漫画人', quote: '更新速度快，阅读体验流畅，是韩漫爱好者的首选网站', year: '2025' },
  { outlet: 'ACG资讯站', quote: '韩漫网凭借丰富的资源和优质的服务赢得了广大读者的信赖', year: '2026' },
];

const orgJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '韩漫网',
  url: 'http://h8wx1.com/',
  description: '韩漫网提供韩国漫画全集免费阅读，支持下拉式在线浏览，是中文韩漫阅读首选平台。',
  email: 'hello@h8wx1.com',
  foundingDate: '2023',
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'customer service',
    email: 'hello@h8wx1.com',
    availableLanguage: ['Chinese'],
  },
  sameAs: [],
};

const aboutPageJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  name: '关于韩漫网 - 韩国漫画在线阅读平台',
  description: '韩漫网创立于2023年，致力于为中文读者打造最优质的韩国漫画在线阅读平台，拥有2000+韩漫资源，日活跃读者超50万。',
  url: 'http://h8wx1.com/about',
};

export default function About() {
  const [formStatus, setFormStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;

    const honeypotField = form.querySelector<HTMLInputElement>('[name="phone_alt"]');
    if (honeypotField && honeypotField.value.trim() !== '') {
      setFormStatus('success');
      form.reset();
      return;
    }

    setFormStatus('loading');
    setFormError('');

    const formData = new FormData(form);

    try {
      const response = await fetch('http://h8wx1.com/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string }; message?: string } = {};
      try {
        parsed = JSON.parse(responseText);
      } catch {
        // ignore parse error
      }

      if (response.ok && parsed.code === 'OK') {
        setFormStatus('success');
        form.reset();
      } else {
        const serverMsg =
          parsed?.meta?.message ||
          parsed?.meta?.detail ||
          parsed?.message ||
          responseText ||
          '提交失败，请稍后再试';
        setFormStatus('error');
        setFormError(String(serverMsg));
      }
    } catch {
      setFormStatus('error');
      setFormError('网络错误，请检查连接后重试');
    }
  };

  return (
    <>
      <title>关于韩漫网_品牌介绍与商务合作_韩国漫画在线阅读平台</title>
      <meta name="description" content="韩漫网创立于2023年，提供2000+韩国漫画资源免费在线阅读，日活跃读者超50万。了解更多关于韩漫网的品牌故事、平台数据、发展历程与商务合作联系方式。" />
      <meta name="keywords" content="关于韩漫网,韩国漫画平台,韩漫网品牌介绍,商务合作,漫画在线阅读" />
      <link rel="canonical" href="http://h8wx1.com/about" />
      <meta name="last-modified" content="2026-07-03" />
      <meta property="og:title" content="关于韩漫网_品牌介绍与商务合作_韩国漫画在线阅读平台" />
      <meta property="og:description" content="韩漫网创立于2023年，提供2000+韩国漫画资源免费在线阅读，日活跃读者超50万。了解更多关于韩漫网的品牌故事、平台数据、发展历程与商务合作联系方式。" />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="http://h8wx1.com/about" />
      <meta property="og:locale" content="zh_CN" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="关于韩漫网_品牌介绍与商务合作_韩国漫画在线阅读平台" />
      <meta name="twitter:description" content="韩漫网创立于2023年，提供2000+韩国漫画资源免费在线阅读，日活跃读者超50万。了解更多关于韩漫网的品牌故事、平台数据、发展历程与商务合作联系方式。" />
      <Navbar />
      <main>
        <script type="application/ld+json">{JSON.stringify(orgJsonLd)}</script>
        <script type="application/ld+json">{JSON.stringify(aboutPageJsonLd)}</script>

        {/* Hero */}
        <section className="relative w-full min-h-[500px] flex items-center justify-center overflow-hidden">
          <div className="absolute inset-0 bg-foreground-950"></div>
          <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/90 via-foreground-950/70 to-foreground-950/95"></div>
          <div className="relative z-10 w-full px-4 md:px-6 text-center pt-20 pb-16">
            <p className="text-xs text-accent-300 tracking-widest mb-4 uppercase">
              ABOUT US
            </p>
            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-background-50 leading-tight">
              关于韩漫网
              <br />
              您身边的韩漫阅读专家
            </h1>
            <p className="mt-6 text-sm md:text-base text-background-50/70 max-w-2xl mx-auto leading-relaxed">
              韩漫网创立于2023年，致力于为中文读者打造最优质的韩国漫画在线阅读平台。
              我们坚持免费、高清、快速更新的服务理念，让每一位韩漫爱好者都能享受到极致的阅读体验。
            </p>
          </div>
          <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background-50 to-transparent"></div>
        </section>

        {/* Platform Stats */}
        <section className="w-full py-14 md:py-20 bg-background-50">
          <div className="w-full px-4 md:px-6">
            <div className="text-center mb-10">
              <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full whitespace-nowrap">
                平台数据
              </span>
              <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mt-3">
                让数据说话
              </h2>
              <p className="text-sm text-foreground-500 mt-2 max-w-lg mx-auto">
                韩漫网持续增长的用户规模与丰富的资源，见证了我们对韩漫阅读的专注与热爱
              </p>
            </div>
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 max-w-4xl mx-auto">
              {platformStats.map((stat) => (
                <div
                  key={stat.label}
                  className="bg-background-100 rounded-lg p-6 text-center border border-background-200/50"
                >
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 mx-auto">
                    <i className={`${stat.icon} text-lg text-accent-500`}></i>
                  </div>
                  <p className="mt-4 text-2xl md:text-3xl font-bold text-foreground-900 whitespace-nowrap">
                    {stat.value}
                  </p>
                  <p className="text-xs text-foreground-500 mt-1 whitespace-nowrap">
                    {stat.label}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Feature Cards */}
        <section className="w-full py-14 md:py-20 bg-background-100">
          <div className="w-full px-4 md:px-6">
            <div className="text-center mb-10">
              <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 text-xs font-medium rounded-full whitespace-nowrap">
                我们的优势
              </span>
              <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mt-3">
                为什么选择韩漫网
              </h2>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
              {features.map((f) => (
                <div
                  key={f.title}
                  className="bg-background-50 rounded-lg px-5 py-6 text-center border border-background-200/50"
                >
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 mx-auto">
                    <i className={`${f.icon} text-lg text-accent-500`}></i>
                  </div>
                  <h3 className="mt-4 text-sm font-semibold text-foreground-900 whitespace-nowrap">
                    {f.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-2 leading-relaxed">
                    {f.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Milestones */}
        <section className="w-full py-14 md:py-20 bg-background-50">
          <div className="w-full px-4 md:px-6">
            <div className="text-center mb-10">
              <span className="inline-block px-3 py-1 bg-secondary-100 text-secondary-700 text-xs font-medium rounded-full whitespace-nowrap">
                发展历程
              </span>
              <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mt-3">
                我们的成长之路
              </h2>
            </div>
            <div className="max-w-3xl mx-auto">
              {milestones.map((m, i) => (
                <div key={m.year} className="flex gap-5">
                  <div className="flex flex-col items-center">
                    <div className="w-10 h-10 rounded-full bg-accent-500 flex items-center justify-center flex-shrink-0">
                      <span className="text-xs font-bold text-background-50 whitespace-nowrap">
                        {m.year}
                      </span>
                    </div>
                    {i < milestones.length - 1 && (
                      <div className="w-0.5 flex-1 bg-accent-200 my-1"></div>
                    )}
                  </div>
                  <div className={`pb-10 ${i === milestones.length - 1 ? 'pb-0' : ''}`}>
                    <h3 className="text-base font-semibold text-foreground-900 whitespace-nowrap">
                      {m.title}
                    </h3>
                    <p className="text-sm text-foreground-500 mt-1">{m.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Media Coverage */}
        <section className="w-full py-14 md:py-20 bg-background-100">
          <div className="w-full px-4 md:px-6">
            <div className="text-center mb-10">
              <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full whitespace-nowrap">
                媒体评价
              </span>
              <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mt-3">
                业界认可
              </h2>
            </div>
            <div className="max-w-3xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-5">
              {mediaCoverage.map((m) => (
                <div
                  key={m.outlet}
                  className="bg-background-50 rounded-lg p-6 border border-background-200/50"
                >
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 mb-4">
                    <i className="ri-double-quotes-l text-accent-500"></i>
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed italic">
                    &ldquo;{m.quote}&rdquo;
                  </p>
                  <p className="mt-4 text-xs font-semibold text-foreground-900 whitespace-nowrap">
                    — {m.outlet}
                  </p>
                  <p className="text-xs text-foreground-400 mt-0.5">{m.year}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact */}
        <section className="w-full py-14 md:py-20 bg-background-50">
          <div className="w-full px-4 md:px-6">
            <div className="text-center mb-10">
              <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full whitespace-nowrap">
                联系我们
              </span>
              <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mt-3">
                随时与我们取得联系
              </h2>
            </div>
            <div className="max-w-2xl mx-auto grid grid-cols-1 sm:grid-cols-3 gap-5">
              <div className="bg-background-100 rounded-lg p-6 text-center border border-background-200/50">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 mx-auto">
                  <i className="ri-mail-line text-lg text-primary-500"></i>
                </div>
                <h3 className="mt-4 text-sm font-semibold text-foreground-900 whitespace-nowrap">
                  电子邮箱
                </h3>
                <p className="text-xs text-foreground-500 mt-1">
                  hello@h8wx1.com
                </p>
              </div>
              <div className="bg-background-100 rounded-lg p-6 text-center border border-background-200/50">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 mx-auto">
                  <i className="ri-wechat-line text-lg text-accent-500"></i>
                </div>
                <h3 className="mt-4 text-sm font-semibold text-foreground-900 whitespace-nowrap">
                  微信公众号
                </h3>
                <p className="text-xs text-foreground-500 mt-1">
                  韩漫网官方
                </p>
              </div>
              <div className="bg-background-100 rounded-lg p-6 text-center border border-background-200/50">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-100 mx-auto">
                  <i className="ri-customer-service-2-line text-lg text-secondary-500"></i>
                </div>
                <h3 className="mt-4 text-sm font-semibold text-foreground-900 whitespace-nowrap">
                  在线客服
                </h3>
                <p className="text-xs text-foreground-500 mt-1">
                  工作日 9:00-18:00
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Business Cooperation Form */}
        <section className="w-full py-14 md:py-20 bg-background-100">
          <div className="w-full px-4 md:px-6">
            <div className="text-center mb-10">
              <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 text-xs font-medium rounded-full whitespace-nowrap">
                商务合作
              </span>
              <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mt-3">
                与我们合作
              </h2>
              <p className="text-sm text-foreground-500 mt-2 max-w-lg mx-auto">
                如果您有广告投放、内容合作、版权授权等商务需求，请填写以下表单，我们会在3个工作日内与您联系
              </p>
            </div>

            <div className="max-w-xl mx-auto">
              <form
                id="business-contact-form"
               
                onSubmit={handleSubmit}
                className="bg-background-50 rounded-lg p-6 md:p-8 border border-background-200/50"
              >
                {/* Honeypot */}
                <div className="sp-fld-wrap" aria-hidden="true">
                  <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" readOnly />
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                  <div>
                    <label htmlFor="bc-name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                      姓名 <span className="text-primary-500">*</span>
                    </label>
                    <input
                      id="bc-name"
                      name="name"
                      type="text"
                      required
                      className="w-full px-4 py-2.5 text-sm bg-background-100 border border-background-200/70 rounded-lg focus:outline-none focus:border-primary-400 transition-colors duration-200"
                      placeholder="请输入您的姓名"
                    />
                  </div>
                  <div>
                    <label htmlFor="bc-company" className="block text-sm font-medium text-foreground-700 mb-1.5">
                      公司名称
                    </label>
                    <input
                      id="bc-company"
                      name="company"
                      type="text"
                      className="w-full px-4 py-2.5 text-sm bg-background-100 border border-background-200/70 rounded-lg focus:outline-none focus:border-primary-400 transition-colors duration-200"
                      placeholder="请输入公司名称"
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                  <div>
                    <label htmlFor="bc-email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                      电子邮箱 <span className="text-primary-500">*</span>
                    </label>
                    <input
                      id="bc-email"
                      name="email"
                      type="email"
                      required
                      className="w-full px-4 py-2.5 text-sm bg-background-100 border border-background-200/70 rounded-lg focus:outline-none focus:border-primary-400 transition-colors duration-200"
                      placeholder="请输入您的邮箱"
                    />
                  </div>
                  <div>
                    <label htmlFor="bc-phone" className="block text-sm font-medium text-foreground-700 mb-1.5">
                      联系电话
                    </label>
                    <input
                      id="bc-phone"
                      name="phone"
                      type="text"
                      className="w-full px-4 py-2.5 text-sm bg-background-100 border border-background-200/70 rounded-lg focus:outline-none focus:border-primary-400 transition-colors duration-200"
                      placeholder="请输入您的电话"
                    />
                  </div>
                </div>

                <div className="mb-4">
                  <label htmlFor="bc-type" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    合作类型 <span className="text-primary-500">*</span>
                  </label>
                  <select
                    id="bc-type"
                    name="cooperation_type"
                    required
                    className="w-full px-4 py-2.5 text-sm bg-background-100 border border-background-200/70 rounded-lg focus:outline-none focus:border-primary-400 transition-colors duration-200 cursor-pointer"
                  >
                    <option value="">请选择合作类型</option>
                    <option value="advertising">广告投放</option>
                    <option value="content">内容合作</option>
                    <option value="copyright">版权授权</option>
                    <option value="promotion">联合推广</option>
                    <option value="other">其他合作</option>
                  </select>
                </div>

                <div className="mb-6">
                  <label htmlFor="bc-message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    合作说明 <span className="text-primary-500">*</span>
                  </label>
                  <textarea
                    id="bc-message"
                    name="message"
                    required
                    maxLength={500}
                    rows={4}
                    className="w-full px-4 py-2.5 text-sm bg-background-100 border border-background-200/70 rounded-lg focus:outline-none focus:border-primary-400 transition-colors duration-200 resize-none"
                    placeholder="请简要描述您的合作需求（500字以内）"
                  ></textarea>
                  <p className="text-xs text-foreground-400 mt-1 text-right">最多500字</p>
                </div>

                {formStatus === 'error' && (
                  <div className="mb-4 p-3 bg-accent-100 text-accent-700 text-sm rounded-lg">
                    {formError}
                  </div>
                )}

                {formStatus === 'success' && (
                  <div className="mb-4 p-3 bg-primary-100 text-primary-700 text-sm rounded-lg">
                    提交成功！我们会在3个工作日内与您联系。
                  </div>
                )}

                <button
                  type="submit"
                  disabled={formStatus === 'loading'}
                  className="w-full px-8 py-3 bg-primary-500 text-background-50 text-sm font-medium rounded-full whitespace-nowrap hover:bg-primary-600 transition-all duration-300 cursor-pointer disabled:opacity-60 disabled:cursor-not-allowed"
                >
                  {formStatus === 'loading' ? '提交中...' : '提交合作申请'}
                </button>
              </form>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="w-full py-14 md:py-20 bg-secondary-500">
          <div className="w-full px-4 md:px-6 text-center">
            <h2 className="font-heading text-2xl md:text-3xl text-background-50">
              准备好开始你的韩漫之旅了吗？
            </h2>
            <p className="mt-3 text-sm text-background-50/70">
              2000+韩漫资源等你来探索，完全免费，立即开始阅读
            </p>
            <Link
              to="/category/action"
              className="mt-6 inline-flex items-center gap-2 px-8 py-3.5 bg-background-50 text-secondary-500 text-sm font-medium rounded-full whitespace-nowrap hover:bg-background-100 transition-all duration-300 cursor-pointer"
            >
              开始阅读
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}